import { render, staticRenderFns } from "./Layer.html?vue&type=template&id=0b27fc36&"
import script from "./Layer.vue?vue&type=script&lang=js&"
export * from "./Layer.vue?vue&type=script&lang=js&"
import style0 from "./Layer.scss?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports